import type { MapaCargo } from '@/components/Configuracao/mapaCargos/mapaCargosTypes'

export const CARGO_HEAD_DE_RELACIONAMENTO_COM_CLIENTE: MapaCargo = 
{
  id: 'head-de-relacionamento-com-cliente',
  titulo: 'Head de Relacionamento com Cliente',
  setor: 'Sucesso do Cliente',
  secoes: [
    {
      id: 'estruturacao-e-gestao-da-area',
      titulo: 'Estruturação e Gestão da Área',
      atividades: [
        'Desenvolver, implementar e evoluir os processos da área de Relacionamento com Cliente.',
        'Definir fluxos, indicadores, rituais e padrões de atendimento e acompanhamento da carteira.',
        'Garantir a correta utilização das ferramentas e processos de gestão do relacionamento.',
        'Criar mecanismos de acompanhamento da saúde da carteira e prevenção de churn.',
        'Estruturar relatórios, indicadores e rotinas de acompanhamento para a diretoria.',
        'Construir e aprimorar metodologias de acompanhamento da experiência do cliente.',
      ],
    },
    {
      id: 'gestao-da-carteira-de-clientes',
      titulo: 'Gestão da Carteira de Clientes',
      atividades: [
        'Conduzir diretamente a gestão da carteira de clientes.',
        'Supervisionar a saúde geral da carteira.',
        'Garantir a atualização dos indicadores de relacionamento e satisfação.',
        'Acompanhar a classificação dos clientes conforme critérios de risco e engajamento.',
        'Monitorar indicadores como NPS, CSAT, Health Score, retenção e expansão de receita.',
        'Atuar preventivamente em situações que possam impactar a experiência do cliente.',
      ],
    },
    {
      id: 'operacao-de-relacionamento-com-cliente',
      titulo: 'Operação de Relacionamento com Cliente',
      atividades: [
        'Conduzir reuniões periódicas com clientes.',
        'Aplicar a metodologia de diagnóstico e acompanhamento da carteira.',
        'Realizar levantamento de percepção, expectativas, gargalos e oportunidades de melhoria.',
        'Registrar atas, encaminhamentos e planos de ação das reuniões realizadas.',
        'Atualizar controles, indicadores e ferramentas de acompanhamento da carteira.',
        'Realizar devolutivas aos clientes sobre tratativas, melhorias e ações executadas.',
        'Garantir o registro adequado das informações nos sistemas e ferramentas utilizadas pela empresa.',
        'Atuar como principal ponto de contato estratégico dos clientes sob sua responsabilidade.',
      ],
    },
    {
      id: 'gestao-de-risco-e-retencao',
      titulo: 'Gestão de Risco e Retenção',
      atividades: [
        'Identificar sinais de risco de churn, insatisfação ou desalinhamento de expectativas.',
        'Conduzir planos de ação para recuperação de contas em atenção ou risco.',
        'Liderar tratativas relacionadas a clientes estratégicos e situações críticas.',
        'Garantir que riscos identificados sejam direcionados e acompanhados até sua resolução.',
        'Promover ações preventivas voltadas à retenção e fortalecimento dos relacionamentos.',
        'Escalar situações críticas para as lideranças responsáveis sempre que necessário.',
      ],
    },
    {
      id: 'conducao-estrategica-de-clientes',
      titulo: 'Condução Estratégica de Clientes',
      atividades: [
        'Conduzir reuniões periódicas e estratégicas com clientes.',
        'Garantir alinhamento entre expectativa do cliente, escopo contratado e entregas realizadas.',
        'Atuar como facilitador na resolução de conflitos e alinhamento entre cliente e operação.',
        'Apoiar negociações relacionadas à continuidade, expansão ou reestruturação de contratos.',
        'Promover alinhamento contínuo entre clientes e equipes envolvidas nos projetos.',
      ],
    },
    {
      id: 'inteligencia-de-negocio-e-geracao-de-insights',
      titulo: 'Inteligência de Negócio e Geração de Insights',
      atividades: [
        'Consolidar informações da carteira para identificação de padrões, oportunidades e riscos.',
        'Gerar insights estratégicos para melhoria da experiência do cliente.',
        'Identificar oportunidades de upsell, cross-sell e expansão de contratos.',
        'Apoiar a liderança na tomada de decisões relacionadas à retenção e crescimento da carteira.',
        'Transformar feedbacks dos clientes em oportunidades de melhoria para a agência.',
        'Analisar tendências de satisfação, churn e desempenho da carteira.',
      ],
    },
    {
      id: 'integracao-com-areas-internas',
      titulo: 'Integração com Áreas Internas',
      atividades: [
        'Atuar em conjunto com Heads, Coordenadores e líderes de squad para alinhamento das demandas dos clientes.',
        'Garantir que problemas identificados sejam direcionados aos responsáveis adequados.',
        'Promover alinhamento entre as áreas de Atendimento, Gestão, Suporte, Projetos, Performance e demais operações.',
        'Facilitar a comunicação entre clientes e equipes internas quando necessário.',
        'Acompanhar a execução dos planos de ação definidos para cada situação.',
      ],
    },
    {
      id: 'governanca-e-controle',
      titulo: 'Governança e Controle',
      atividades: [
        'Garantir o registro adequado das interações, decisões e encaminhamentos relacionados aos clientes.',
        'Elaborar e manter atas, relatórios, registros e documentos de acompanhamento da carteira.',
        'Garantir a atualização dos indicadores da área.',
        'Elaborar e apresentar reports semanais e mensais da carteira.',
        'Monitorar a evolução dos indicadores e propor melhorias contínuas nos processos.',
        'Garantir rastreabilidade e organização das informações relacionadas aos clientes.',
      ],
    },
    {
      id: 'planejamento-estrategico',
      titulo: 'Planejamento Estratégico',
      atividades: [
        'Definir metas e indicadores da área de Relacionamento.',
        'Desenvolver iniciativas voltadas ao aumento da satisfação e fidelização da carteira.',
        'Contribuir para o crescimento sustentável da receita recorrente da agência.',
        'Apoiar a construção de uma cultura organizacional orientada à experiência do cliente.',
        'Participar de decisões estratégicas relacionadas à retenção, expansão e evolução da carteira.',
      ],
    },
  ],
}
